import React, {ReactElement} from 'react';
import {NxFormikProps} from '../model/SharedTypes';
import NxDatePicker, {NxDatePickerProps} from './NxDatePicker';
import {useField, useFormikContext} from 'formik';
import {isFieldRequired, useValidationSchema} from '../form/ValidationService';


export type NxFormikDatePickerProps = Omit<NxDatePickerProps, NxFormikProps> & {
  name: string;
  validate?: (value: string | null) => string | void | Promise<string | void>;
};

export const NxFormikDatePicker = (props: NxFormikDatePickerProps): ReactElement => {
  const [field, meta, helpers] = useField(props);
  const {onChange, onBlur, ...rest} = field;

  const context = useFormikContext();
  const validationSchema = useValidationSchema();

  return <NxDatePicker
                       positionAbsoluteError={false}
                       {...rest}
                       {...props}
                       error={meta.error}
                       disabled={props.disabled || context.isSubmitting}
                       required={props.required || isFieldRequired(validationSchema, field.name)}
                       onBlur={(): void => helpers.setTouched(true, context.validateOnBlur)}
                       onChange={(value: string | null): void => helpers.setValue(value, context.validateOnChange)} />;
}